import axios from 'axios';
const api = axios.create({
  baseURL: 'https://master.filadelfiablessingfamily.org/api', 
});
const fileBaseURL = 'https://master.filadelfiablessingfamily.org/documents/';
const qrPath = 'https://master.filadelfiablessingfamily.org/qrcode/';

// Function to handle login
export const loginPost = async (email, password) => {
  try {
    const response = await api.post('/login', { email, password });
    return response.data;
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
};
export const daftarPost = async (nama,hp,email, password) => {
  try {
    const response = await api.post('/daftar', { nama,hp,email, password });
    return response.data;
  } catch (error) {
    console.error('Error daftar in:', error);
    throw error;
  }
};
export const verifyOtp = async (email,code) => {
  try {
    const response = await api.post('/verify-otp', {email,code});
    return response.data;
  } catch (error) {
    console.error('Error verify in:', error);
    throw error;
  }
};
export const listDokumen = async () => {
  try {
    const response = await api.get('/list-dokumen');
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
export const saveProfileData = async (formData) => {
  try {
    const response = await api.post('/update-profil', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting request service:', error);
    throw error;
  }
};
export const codeReset = async (formData) => {
  try {
    const response = await api.post('/reset-code', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting request service:', error);
    throw error;
  }
};
export const validateResetCode = async (formData) => {
  try {
    const response = await api.post('/password-validate', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting request service:', error);
    throw error;
  }
};
export const resetPassword = async (formData) => {
  try {
    const response = await api.post('/reset-password', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting request service:', error);
    throw error;
  }
};
export { api,fileBaseURL,qrPath };
